
import { Component, HostListener, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { DatePipe, isPlatformBrowser} from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { URLS } from 'src/app/_config/api.config';
import { ApiService } from 'src/app/services/api-data.service';
import { Subscription } from 'rxjs';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Title, Meta } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-complete-guide',
  templateUrl: './complete-guide.component.html',
  styleUrls: ['./complete-guide.component.scss']
})
export class CompleteGuideComponent implements OnInit {

  articleData: any;
  noArticle = false;
  carouselReady: boolean = false;
  articleTitle: any;
  isLoading = false;
  articleDataAll: any;
  showScroll = false;
  faqData: any = [];
  url: string = '';
  title: string = '';

  private subscription: Subscription = new Subscription();

  constructor(
    private router: Router,
    private dataService: ApiService,
    private toastr: ToastrService,
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private metaService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects;
        const newUrl = url?.split('/articles/')[1]?.replace(/\-/g, ' '); // Get everything after /articles/
        this.articleTitle = newUrl;
      }
    });
  }

  ngOnInit(): void {


    // Set the page title dynamically
    this.titleService.setTitle('A Complete Guide to Planning a Catholic Funeral Mass | Catholic Legacy');
    this.metaService.updateTag({ property: 'og:title', content: 'A Complete Guide to Planning a Catholic Funeral Mass | Catholic Legacy' });
    this.metaService.updateTag({ name: 'description', content: 'Learn how to plan a Catholic funeral Mass with key rites and decisions for a meaningful, faith-based farewell. Start today with Catholic Legacy’s free tool.' });
    this.metaService.updateTag({ property: 'og:description', content: 'Learn how to plan a Catholic funeral Mass with key rites and decisions for a meaningful, faith-based farewell. Start today with Catholic Legacy’s free tool.' });
    this.metaService.updateTag({ property: 'og:image', content: 'https://clg-prod-static.s3.us-east-2.amazonaws.com/articles/catholicfuneralmass.jpg' });
    this.metaService.updateTag({ property: 'og:type', content: 'website' });
    this.metaService.updateTag({ property: 'og:url', content: `${environment.webUrl}` + '/articles/a-complete-guide-to-planning-a-catholic-funeral-mass-step-by-step' });

    if (this.articleTitle) {
      this.getArticle();
    }

    setTimeout(() => {
      this.carouselReady = true;
    }, 2000); // Adjust the delay time as needed
  }

  customOptions: OwlOptions = {
    loop: false,
    margin: 20, // Spacing between items
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    navText: [
      '<img src="../../../assets/images/left-orange-arrow.webp">',
      '<img src="../../../assets/images/right-orange-arrow.webp">'
    ],
    stagePadding: 15, // Adds padding on sides
    responsive: {
      0: {
        items: 1,
        stagePadding: 10
      },
      600: {
        items: 2,
        stagePadding: 15
      },
      1024: {
        items: 3,
        // stagePadding: 30
      }
    },
    nav: true
  };

  onHome() {
    this.router.navigateByUrl('/');
  }

  onArticle(){ 
    this.router.navigateByUrl('/articles');
  }

  getArticle() {
    this.isLoading = true;
    this.subscription.add(
      this.dataService.get(URLS.articleDetail + `?title=${this.articleTitle}`).subscribe(data => {
        if (data['code'] == 200) {
          this.articleDataAll = data['data'];
          this.articleData = data['data']['relatedArticles'];
          if (data['data']['relatedArticles'].length <= 0) {
            this.noArticle = true;
            // this.isLoading=false;

          } else {
            this.noArticle = false;
            // this.isLoading=false;
          }
          this.faqData = data['data']['articleFaq'];
          if (this.faqData?.length > 0)
            this.faqData.forEach(item => item['isCollapsed'] = true);
          this.isLoading = false;
          window.scrollTo({ top: 0, behavior: 'smooth' })

        } else {
          this.toastr.error(data['message'], "Error");
          this.isLoading = false;
        }
      }, error => {
        this.toastr.error(error['message'], "Error");
        this.isLoading = false;
      })
    )
  }

  readMore(data) {
    if (data.authorName) {
      // const formattedTitle = data.title.replace(/\?/g, '').replace(/\s+/g, '-');
      const formattedTitle = data.title.replace(/[^a-zA-Z0-9- ]/g, '').replace(/\s+/g, '-');
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['articles/', formattedTitle.toLowerCase()]);
      });
    }
    else
      window.open(data.url, '_blank');
  }

  renderHTmlTags(description) {
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }

  // removeHtmlTags(input: string): string {
  //   if (typeof input !== 'string') {
  //     return ''; // Handle non-string input
  //   }

  //   // Remove HTML tags
  //   let text = input.replace(/<\/?[^>]+(>|$)/g, '');
  //   text = text.replace(/&nbsp;/g, '');

  //   // Decode HTML entities
  //   const textarea = document.createElement("textarea");
  //   textarea.innerHTML = text;
  //   return textarea.value;
  // }
  removeHtmlTags(input: string): string {
    if (typeof input !== 'string') {
      return ''; // Handle non-string input
    }

    // Remove HTML tags
    
    
    const matches = [...input.matchAll(/<p[^>]*>([\s\S]*?)<\/p>/gi)];
    let firstPContent = matches.length > 0 ? matches[0][1] : '';
    input=input.replace(firstPContent, '');
    firstPContent=firstPContent.replace(/<\/?[^>]+(>|$)/g, '')
    firstPContent=firstPContent.replace(/&nbsp;/g, '');

    let text = input.replace(/<\/?[^>]+(>|$)/g, '');
    text= text.replace(/&nbsp;/g,'');

    // Decode HTML entities
    if (isPlatformBrowser(this.platformId)) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = firstPContent +' '+ text;
    return textarea.value;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    // Show the button when scrolled 200px down
    this.showScroll = window.scrollY > 700;
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  toggleAccordion(data: any) {
    data.isCollapsed = !data.isCollapsed; // Toggle the clicked accordion
  }

  share(platform: string) {
    const shareUrl = this.getShareUrl(platform);
    const windowFeatures = 'width=600,height=400,menubar=no,toolbar=no,location=no,status=no';
    window.open(shareUrl, '_blank', windowFeatures);
  }
  getShareUrl(platform: string): string {
    switch (platform) {
      case 'facebook':
        return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`${environment.webUrl}${this.router.url}`)}`;
      case 'twitter':
        return `https://twitter.com/intent/tweet?url=${encodeURIComponent(`${environment.webUrl}${this.router.url}`)}&text=${encodeURIComponent(this.articleDataAll.title)}`;
      case 'linkedin':
        return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(`${environment.webUrl}${this.router.url}`)}`;
      default:
        return '';
    }
  }

}
